import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { GridApi } from 'ag-grid-community';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { EmailTemplatesService } from 'src/app/services/administration/email-templates.service';
import { CommonService } from 'src/app/services/common.service';
import { EmailTemplatesModelViewComponent } from './email-templates-model-view/email-templates-model-view.component';
import { UserService } from 'src/app/services/user.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-email-templates-summary',
  templateUrl: './email-templates-summary.component.html',
  styleUrls: ['./email-templates-summary.component.scss']
})
export class EmailTemplatesSummaryComponent implements OnInit {

  columnDefs : any;
  operations : any[];
  tempoperation : any[];
  gridApi: GridApi;
  selectedRow : any;
  hasAddPermission: boolean;
  rowData : any[];
  StatusList:any[] =[];
  EmailTemplateSearchForm: UntypedFormGroup;
  ApplicableProgrmaslst:any[];
  collapesedOrNot:boolean=false;
  constructor(private modalService: NgbModal,
    private commonService: CommonService,
              private emailtemplatesservice:EmailTemplatesService,
    private fb: UntypedFormBuilder,
              private userService:UserService) 
              {
    this.EmailTemplateSearchForm = this.fb.group(
      {
        Name: [""],
        ModuleId: ["", [Validators.required]],
        Status: [""]
      });
  }

  ngOnInit(): void {
    // this.StatusList =[{label:"All" , value:""}];
    this.StatusList.push({
      label : "All" , value:"" , checked: true
    })
    this.StatusList.push({
      label : "Active" , value:"1" 
    })
    this.StatusList.push({
      label : "Inactive" , value:"0"
    })



    this.getApplicablePrograms();

    this.columnDefs= [
      {
        "headerName": "Name",
        "field": "Name"
      },
      {
        "headerName": "Applicable Program",
        "field": "ModuleId"
      },
      {
        "headerName": "Application Type",
        "field": "MappedAppTypesNames"
      },
      {
        "headerName": "Status",
        "field": "RecordState"
      }
    ];

    this.tempoperation = [];

    if (this.commonService.getScreenPermission("619", "N")) {
      this.hasAddPermission = true;
    }

    if (this.commonService.getScreenPermission("619", "E")) {
      this.tempoperation.push({
        "name": "Edit",
        "id": "edit"
      });
    }

    if (this.commonService.getScreenPermission("619", "V")) {
      this.tempoperation.push({
        "name": "View",
        "id": "View"
      });
    }

    if (this.commonService.getScreenPermission("619", "D")) {
      this.tempoperation.push({
        "name": "Delete",
        "id": "Delete"
      });
    }

    this.operations = this.tempoperation.map(operation => {
      return { name: operation.name, callback: this[operation.id], self: this }
    });

    this.GetEmailTemplateSummary();
  }

  Add(){
    const Modalref = this.modalService.open(EmailTemplatesModelViewComponent, {
      backdrop: false,
      keyboard: false,
      animation: true,
      windowClass:'modal-llg right modal-right'
    });

    Modalref.componentInstance.Content = {
      heading: 'Add',
      content: {},
    }
    Modalref.result.then((result) => {
      this.GetEmailTemplateSummary();
    });
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback(this.emailtemplatesservice);
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  getApplicablePrograms(){
    this.emailtemplatesservice.getApplicablePrograms(this.userService.getOrgCode()).subscribe(result=>{
      if(result != null && result != undefined){
        this.ApplicableProgrmaslst = result;
        //this.ApplicableProgrmaslst=[{label : "Select" , value : ""}].concat(this.ApplicableProgrmaslst)
      }
    });
  }

  Search(mode:string){
    if(this.ValidateForm(mode)){
      this.GetEmailTemplateSummary();
    }
  }

  GetEmailTemplateSummary = () =>{
    this.emailtemplatesservice.GetEmailTemplatesSearchSummary(this.EmailTemplateSearchForm.getRawValue()).subscribe(result=>{
      if(result != null && result != undefined){
        result.forEach(element =>{
          element.RecordState = element.RecordState ? "Active":"Inactive";

          // if(element.ModuleId == "2"){
          //   element.ModuleId = "IST";
          // }
          // if(element.ModuleId == "4"){
          //   element.ModuleId = "Grants";
          // }
          // if(element.ModuleId == "5"){
          //   element.ModuleId = "EAP";
          // }
        });
        this.rowData = result;
      }
    });
  }

  Clear() {
    this.EmailTemplateSearchForm.patchValue({
      Name: "",
      ModuleId:"",
      Status:""
    });
  }

  ViewAll() {
    this.Clear();
    this.Search("ViewAll");
  }

  ValidateForm(mode: string): boolean {
    let isValid = true;
    if (mode != "ViewAll") {
      var err: any = [];
      if (!this.EmailTemplateSearchForm.valid) {
          if (this.EmailTemplateSearchForm.get('ModuleId')?.value == "") {
              err.push("Please select the Applicable Program to perform Search");
          }
          if (err && err.length > 0) {
           const Modalref= this.modalService.open(MessageBoxComponent, {
              backdrop: false,
              keyboard: false,
              animation: true
            });
            Modalref.componentInstance.Content =  { 
              heading: "Validation Message(s)", 
              content: { heading: '', description:err} 
            } 
            isValid = false;
          }
      }
    }
    return isValid;
  }

  edit(RcordData:any) {
    const Modalref = this['self'].modalService.open(EmailTemplatesModelViewComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true
    });


    Modalref.componentInstance.Content = {
      content: { EmailTempId: RcordData['EmailTempID'] },
      heading: "Edit"
    }
    Modalref.result.then((result) => {
      this['self'].GetEmailTemplateSummary();
    });
  }

  View(RcordData:any) {
    const Modalref = this['self'].modalService.open(EmailTemplatesModelViewComponent, {
       backdrop: false,
       keyboard: false,
       windowClass: 'modal-llg right modal-right',
       animation: true
     });

 
     Modalref.componentInstance.Content = {
      heading: 'View',
      content: {
        EmailTempId: RcordData['EmailTempID'],
      }
    }
    Modalref.result.then((result) => { 
      this['self'].GetEmailTemplateSummary();
    });
  }

  Delete(RcordData:any) {
    const Modalref = this['self'].modalService.open(DeleteBoxComponent, {
      backdrop: false,
      keyboard: false,
      animation: true
      
    });
    Modalref.componentInstance.Content = {
      heading: "Delete",
      custommessage: "Are you sure you want to delete this email template '" + this['self'].selectedRow['Name'] + "' ?",
      ProceedButtonName:"Delete", 
      TerminateButtonName:"Cancel"
    }
    Modalref.result.then(result=>{
      if(result == "okclick"){
        this['self'].emailtemplatesservice.DeleteEmailTemplateById(RcordData['EmailTempID']).subscribe(result=>{
          if(result != null && result != undefined){
            if (result.Status) {
              this['self'].commonService.SuccessBanner(result.errMessage);
              this['self'].GetEmailTemplateSummary();
            } else {
              this['self'].commonService.ValidationBanner(result.errMessage);
              // this['self'].modalService.show(MessageBoxComponent, {
              //   backdrop: false,
              //   keyboard: false,
              //   ignoreBackdropClick: true,
              //   animated: true,  
              //   data: { 
              //     heading: "Validation Message(s)", 
              //     content: { heading: '', description:result.errMessage} 
              //   } 
              // });
            }
          }
          else {
            this['self'].commonService.ValidationBanner("Unable to save");
            // this['self'].modalService.show(MessageBoxComponent, {
            //   backdrop: false,
            //   keyboard: false,
            //   ignoreBackdropClick: true,
            //   animated: true,  
            //   data: { 
            //     heading: "Validation Message(s)", 
            //     content: { heading: '', description:"Unable to save"} 
            //   } 
            // });
          }
        },
          (err) => {
            this['self'].commonService.ValidationBanner(err);
            // this['self'].modalService.show(MessageBoxComponent, {
            //   backdrop: false,
            //   keyboard: false,
            //   ignoreBackdropClick: true,
            //   animated: true,  
            //   data: { 
            //     heading: "Validation Message(s)", 
            //     content: { heading: '', description:err} 
            //   } 
            // });
          }
        )
      }
    });
  }

  onRowDoubleClicked($event)
  {

  }
}
